import { useFullStory, usePendo, useSettingsStore, useUserStore } from '@local/shared';
import { useEffect, useState } from 'react';
import { useIs40xPage } from './use-is-40x-page';
import { useProcessUtmSource } from './use-process-utm-source';

export const useInitializeApp = () => {
    const [isInitialized, setIsInitialized] = useState<boolean>(false);
    const is40x = useIs40xPage();
    const settingsStore = useSettingsStore();
    const userStore = useUserStore();
    const pendo = usePendo();
    const fullStory = useFullStory();
    const processUtmSource = useProcessUtmSource();

    useEffect(() => {
        const init = async () => {
            if (isInitialized) {
                return;
            }
            if (is40x) {
                // error pages are anonymous and without tracking
                setIsInitialized(true);
                return;
            }
            const user = await userStore.initUser();
            if (!user) {
                // "initUser" will redirect to auth url (or throw generic error if something goes wrong). So, no need to proceed with rendering.
                return;
            }
            // User is there. Now we need to load FS and Pendo to have tracking of auth events
            await Promise.all([pendo.initialize(user), fullStory.initialize(user)]);
            // Check utm source, track if exist and remove utm_source param from the URL
            await processUtmSource(Boolean(user?.hasAccess));
            if (user?.hasAccess) {
                await settingsStore.loadSettings();
            }
            setIsInitialized(true);
        };
        init().then();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return isInitialized;
};
